import { CheckboxChangeEventType, HfCheckbox, OdinController } from '@myosh/odin-components';
import { PickList } from 'primereact/picklist';
import { useMemo, useRef } from 'react';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FiltersType } from '../../../../redux/config/filters-api';

interface WidgetNotBlankProps {
  sourceData?: FiltersType;
  targetData?: Array<string>;
  control: Control;
  notBlankValue?: boolean;
  isFetching?: boolean;
  isError?: boolean;
}

const WidgetNotBlankComponent = ({
  sourceData,
  targetData = [],
  control,
  notBlankValue,
  isFetching,
  isError,
}: WidgetNotBlankProps) => {
  const styleRef = useRef<Record<string, string>>({ height: '30rem' });
  const { t } = useTranslation();

  const source = useMemo(() => {
    if (!sourceData) return [];
    return sourceData.values.filter((val) => !(targetData || []).includes(val));
  }, [sourceData, targetData]);

  return (
    <div className="gap-2 py-2">
      <HfCheckbox
        control={control}
        name="notBlank"
        label={t('notBlank')}
        fieldValueConverter={(value) => (value as CheckboxChangeEventType).checked}
      />

      {!notBlankValue && (
        <>
          <span className="whitespace-pre-wrap p-3 text-sm font-normal italic">{t('values')}</span>
          {isError ? (
            <p className="p-3 text-error">{t('getGlobalFiltersError')}</p>
          ) : isFetching ? (
            <p className="p-3">{t('loading')}...</p>
          ) : (
            <OdinController
              name="globalFiltersValues"
              control={control}
              render={({ field: { onChange, value: target } }) => (
                <PickList
                  source={source}
                  target={target}
                  dataKey="__value"
                  onChange={(event) => {
                    onChange(event.target);
                  }}
                  sourceStyle={styleRef.current}
                  targetStyle={styleRef.current}
                  className="picklist"
                  showSourceControls={false}
                  showTargetControls={false}
                />
              )}
            />
          )}
        </>
      )}
    </div>
  );
};

export default WidgetNotBlankComponent;
